export const Filter = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14 2V3L10 8C10.0002 9.66667 10 11.3333 10 13L9 14H6C6 12 5.99936 10 6 8L2 3V2H14Z'
      fill='inherit'
    />
  </svg>
);
